export default {
  orderWarehouseID: 'คลังสินค้า',
  orderWarehouseName: 'คลังสินค้า',
  orderCustomerName: 'ชื่อ - สกุล ลูกค้า',
  orderCustomerSocialName: 'ชื่อโชเซี่ยล',
  orderCustomerPhone: 'เบอร์โทรศัพท์',
  orderCustomerEmail: 'อีเมล์',
  orderCustomerAddress: 'ที่อยู่',
  orderCustomerPostal: 'รหัสไปษรณีย์',
  orderShippingType: 'การจัดส่ง',
  orderShippingBy: 'ผู้ให้บริการ การจัดส่ง',
  orderPaymentType: 'วิธีการชำระเงิน',
  orderPaymentSelectedBank: 'ธนาคารสำหรับกาารชำระเงิน',
  orderPaymentDate: 'วันที่ชำระเงิน',
  orderPaymentImage: 'รูปภาพ',
  orderSaleID: 'พนักงานขาย',
  orderSaleName: 'พนักงานขาย',
  orderPaymentCOD: 'บริการเก็บเงินปลายทาง',
  orderVerifyCOD: 'ยืนยันการจัดส่ง COD',
  price: 'ราคาขาย',
  qty: 'จำนวนชิ้น',
  discountPercent: 'ส่วนลด %',
  discount: 'ส่วนลด',
  buyQty: 'จำนวน'
};
